import { type LoyaltyRegistrationStep } from '../../api/loyalty';
import { type InsufficientItem } from '../hooks';

interface ModalsControllers {
    onOutdatedItemPrices?: () => void;
    onOutdatedDeliveryPrices?: () => void;
    onMinimumOrderAmountNotMet?: () => void;
    onPromoCodeUsageLimitExceeded?: () => void;
    onInvalidEmail: () => void;
    onInvalidPhone: () => void;
    onSubmissionError: (errorDescription?: string) => void;
    onOutdatedStock?: (insufficientItems?: InsufficientItem[]) => void;
    onPayBoxModal: () => void;
    onOutdatedLoyaltyConditions?: () => void;
    onLoyaltyApplyError?: () => void;
    onInvalidDeliveryFloor?: () => void;
    onOzonRegistrationError?: () => void;
    onUpdateOrderFailure?: () => void;
    onLoyaltyPromo?: () => void;
    onLoyaltyRegister?: (step: LoyaltyRegistrationStep) => void;
}

class ModalsService {
    private modalsControllers?: ModalsControllers;

    constructor() {
        this.modalsControllers = undefined;
    }
    init(modalsControllers: ModalsControllers) {
        this.modalsControllers = modalsControllers;
    }
    public onOutdatedItemPrices() {
        this.modalsControllers?.onOutdatedItemPrices?.();
    }
    public onOutdatedDeliveryPrices() {
        this.modalsControllers?.onOutdatedDeliveryPrices?.();
    }
    public onMinimumOrderAmountNotMet() {
        this.modalsControllers?.onMinimumOrderAmountNotMet?.();
    }
    public onPromoCodeUsageLimitExceeded() {
        this.modalsControllers?.onPromoCodeUsageLimitExceeded?.();
    }
    public onInvalidEmail() {
        this.modalsControllers?.onInvalidEmail();
    }
    public onInvalidPhone() {
        this.modalsControllers?.onInvalidPhone();
    }
    public onSubmissionError(errorDescription?: string) {
        this.modalsControllers?.onSubmissionError?.(errorDescription);
    }
    public onOutdatedStock(insufficientItems?: InsufficientItem[]) {
        this.modalsControllers?.onOutdatedStock?.(insufficientItems);
    }
    public onPayBoxModal() {
        this.modalsControllers?.onPayBoxModal();
    }
    public onOutdatedLoyaltyConditions() {
        this.modalsControllers?.onOutdatedLoyaltyConditions?.();
    }
    public onLoyaltyApplyError() {
        this.modalsControllers?.onLoyaltyApplyError?.();
    }
    public onInvalidDeliveryFloor() {
        this.modalsControllers?.onInvalidDeliveryFloor?.();
    }
    public onOzonRegistrationError() {
        this.modalsControllers?.onOzonRegistrationError?.();
    }
    public onUpdateOrderFailure() {
        this.modalsControllers?.onUpdateOrderFailure?.();
    }
    public onLoyaltyPromo() {
        this.modalsControllers?.onLoyaltyPromo?.();
    }
    public onLoyaltyRegister(step: LoyaltyRegistrationStep) {
        this.modalsControllers?.onLoyaltyRegister?.(step);
    }
}

export const modalsService = new ModalsService();
